<template>
    <Modal2
        @cancel="$emit('cancel')"
        @ok="saveButtonClickHandler"
        show-footer
        :ok-text="'Save'"
        :title="form.name.toUpperCase() || 'New Web Hook'"
    >
        <div id="webhook-form" class="web-hook-container">
            <a-alert
                v-if="$validator.errors.items.length && isSubmitClicked"
                :message="$t('message.error')"
                class="mb-2"
                showIcon
                type="error"
            >
                <div slot="description">
                    <div v-for="err of $validator.errors.items">
                        <span>
                            {{ err.msg }}
                        </span>
                    </div>
                </div>
            </a-alert>
            <a-form class="d-flex flex-column justify-content-center">
                <div class="form-subtitle"><span style="color: red">*</span> {{ $t("chatbotv2.webhookName") }}</div>
                <a-form-item class="mb-0">
                    <a-input
                        :placeholder="$t('chatbotv2.yourWebHookName')"
                        v-model="form.name"
                        v-validate="'required'"
                        :name="$t('chatbotv2.yourWebHookName')"
                    />
                </a-form-item>
                <div class="form-subtitle"><span style="color: red">*</span> {{ $t("chatbotv2.webHookUrl") }}</div>
                <a-form-item class="mb-0" name="url" style="position: relative">
                    <a-input
                        :style="{ borderColor: urlError ? 'red' : '#d9d9d9' }"
                        :placeholder="$t('chatbotv2.yourWebHookUrl')"
                        v-model="form.url"
                        v-validate="'required'"
                        :name="$t('chatbotv2.webHookUrl')"
                        @blur="urlInputOnBlurHandler"
                    />
                    <label
                        style="position: absolute; bottom: -42px; left: 0; color: red; margin: 0; padding: 0"
                        v-if="urlError"
                    >
                        {{ $t("chatbotv2.urlTypeError") }}</label
                    >
                </a-form-item>
                <div class="form-subtitle">{{ $t("chatbotv2.webHookToken") }}</div>
                <a-form-item class="mb-0">
                    <a-input :placeholder="$t('chatbotv2.yourVerificationToken')" v-model="form.verificationToken" />
                </a-form-item>
                <div class="relative-header">
                    <div class="form-subtitle">{{ $t("chatbotv2.basicAuth") }}</div>
                    <div class="d-flex headers" style="gap: 12px">
                        <a-form-item class="mb-0 w-100">
                            <a-input
                                :placeholder="$t('chatbotv2.username')"
                                v-model="form.basicAuthentication.username"
                            />
                        </a-form-item>
                        <a-form-item class="mb-0 w-100">
                            <a-input
                                :placeholder="$t('chatbotv2.password')"
                                v-model="form.basicAuthentication.password"
                            />
                        </a-form-item>
                    </div>
                </div>
                <div class="headers-group">
                    <div class="form-subtitle">Headers</div>

                    <div v-for="(header, index) of anotherHeaders" class="d-flex headers" style="gap: 12px">
                        <a-form-item class="mb-0 w-100">
                            <a-input :placeholder="$t('chatbotv2.enterKey')" v-model="header.key" />
                        </a-form-item>
                        <a-form-item class="mb-0 w-100 header-input">
                            <a-input :placeholder="$t('chatbotv2.value')" v-model="header.value" />
                        </a-form-item>
                        <div class="delete-button" @click="deleteHeader(index)">
                            <md-icon>delete</md-icon>
                        </div>
                    </div>
                </div>
            </a-form>
        </div>
    </Modal2>
</template>

<script>
import SideMenuBar from "../../../../SideMenuBar.vue";
import { mapActions, mapState } from "vuex";
import { message } from "ant-design-vue";
import Modal2 from "../../../../../../../components/common/Modal2.vue";
import Modal from "../../../../../../../components/common/Modal2.vue";

export default {
    name: "WebHookForm",
    components: { Modal, Modal2, SideMenuBar },
    props: ["id"],
    data() {
        return {
            loading: true,
            editMode: false,
            countEmptyHeader: 0,
            selectedWebHook: {},
            isError: false,
            urlError: false,
            isSubmitClicked: false,
            anotherHeaders: [{ key: "", value: "" }],
            form: {
                name: "",
                url: "",
                verificationToken: "",
                basicAuthentication: {
                    username: "",
                    password: "",
                },
                headers: [],
            },
        };
    },
    computed: {
        ...mapState({
            allWebHooks: (state) => state.CB.allWebHooks,
        }),
    },

    methods: {
        ...mapActions({
            fetchUserWebHooks: "CB/fetchUserWebHooks",
            createNewWebHook: "CB/createNewWebHook",
            updateWebHook: "CB/updateWebHook",
        }),

        urlInputOnBlurHandler() {
            try {
                new window.URL(this.form.url);
                this.urlError = false;
            } catch (e) {
                this.urlError = true;
            }
        },
        async saveButtonClickHandler() {
            this.isSubmitClicked = true;
            this.loading = true;
            this.$validator.validateAll().then(async (response) => {
                if (response) {
                    if (this.form.name && this.form.url) {
                        this.form.headers = this.anotherHeaders.filter((header) => header.key !== "");
                        //update

                        if (this.id) {
                            await this.updateWebHook({ id: this.id, payload: this.form });
                            this.isSubmitClicked = false;

                            this.$emit("confirm");
                            this.loading = false;
                            return message.success(this.$t("chatbotv2.saveSuccessfully"));
                        }
                        //save
                        await this.createNewWebHook(this.form);
                        this.isSubmitClicked = false;

                        this.$emit("confirm");
                        this.loading = false;
                        return message.success(this.$t("chatbotv2.saveSuccessfully"));
                    }
                } else {
                    this.loading = false;
                }
            });
        },
        deleteHeader(headerIndex) {
            this.anotherHeaders = this.anotherHeaders.filter((header, index) => headerIndex !== index);
        },
    },
    async mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 1000);
        if (this.id) {
            const webhook = this.allWebHooks.find((webHook) => webHook._id === this.id);
            if (!webhook) return this.$emit("close");
            this.form = { ...webhook };
            await this.fetchUserWebHooks();
            this.anotherHeaders = this.form.headers;
        }
    },
    watch: {
        anotherHeaders: {
            handler() {
                let allFilled = this.anotherHeaders.every((header) => header.key !== "");
                this.anotherHeaders.forEach((elem, index, arr) => {
                    if (elem.key === "" && elem.value === "") this.countEmptyHeader++;
                });
                if (allFilled) {
                    this.anotherHeaders.push({ key: "", value: "" });
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#webhook-form {
    &.web-hook-container {
        width: 100%;
        padding: 20px 25px;
        height: auto;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .page-name {
                display: flex;
                font-size: 27px;
                line-height: 28px;
                user-select: none;

                .routes {
                    display: flex;
                    margin-right: 15px;

                    p {
                        cursor: pointer;
                        color: #516173;
                        transition: 3ms;
                        margin: 0;
                        padding: 0;
                        margin-right: 10px;
                        font-size: 22px;
                        line-height: 28px;
                    }

                    .arrow {
                        cursor: pointer;
                        font-size: 22px;
                        line-height: 28px;
                    }

                    &:hover {
                        p {
                            color: #006cff;
                            opacity: 0.8;
                        }

                        .arrow {
                            color: #006cff;
                            opacity: 0.8;
                        }
                    }
                }

                .web-hook-name {
                    font-size: 22px;
                    line-height: 28px;
                }
            }

            .button-container {
                height: 37px;
                min-width: 80px;
                cursor: pointer;
                user-select: none;

                .save-button {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #006cff;
                    border: 1px solid #006cff;
                    color: #fff;
                    border-radius: 4px;
                    padding: 0px 10px;
                    color: white;
                    font-weight: 600;
                }
            }
        }

        .ant-form {
            margin-top: 20px;

            .form-subtitle {
                margin-bottom: 3px;
                font-size: 16px;
                line-height: 20px;
                color: #22272d;
            }

            .ant-form-item {
                margin-bottom: 25px !important;

                input {
                    min-height: 37px !important;
                    border-radius: 6px !important;
                }
            }

            .headers-group {
                .headers {
                    display: flex;
                    align-items: center;

                    .ant-form-item {
                        margin-bottom: 5px !important;
                    }

                    .delete-button {
                        cursor: pointer;
                        width: 24px;
                        height: 24px;
                        margin-bottom: 5px;

                        i {
                            width: 100%;
                            height: 100%;
                            color: #9ba6b3;
                        }

                        &:hover {
                            i {
                                opacity: 0.8 !important;
                            }
                        }
                    }
                }
            }
        }
    }
}

.relative-header {
    width: calc(100% - 36px);
}
</style>
